/** @jsxImportSource @emotion/react */
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateStoreForm } from "../components/MutateStoreForm";
import { useGetAdyenAccountHolderStore } from "../../service/adyen-account-holders-api";
import { SpinnerBlock } from "../../../common/Spinner";

export const EditStorePage = () => {
  const { storeId } = useParams();

  const { data: store, isLoading } = useGetAdyenAccountHolderStore(storeId);

  return (
    <RouteFullScreenModal title="Edit store">
      <Divider />
      {isLoading ? <SpinnerBlock /> : <MutateStoreForm store={store} />}
    </RouteFullScreenModal>
  );
};
